import { css } from '@linaria/atomic';
import { getFontColorClassName } from '../../helpers/font-color.linaria';
import { getTextAlignClassName } from '../../helpers/text-align.linaria';
import {
  textBaseStyle,
  getTextSizeClassName,
  getTextWeightClassName,
  type FontWeight,
  type TextSize,
} from '../text/text-style-helpers';

export type TextLinkProps = {
  isButton: boolean;
  size: TextSize;
  color: 'primary' | 'error';
  textAlign: any;
  weight: FontWeight;
  disabled: boolean | undefined;
};

export const buttonStyles = css`
  position: relative;
  -webkit-tap-highlight-color: transparent;
  background-color: transparent;
  outline: 0;
  border: 0;
  /* Remove the margin in Safari */
  margin: 0;
  border-radius: 0;
  /* Remove the padding in Firefox */
  padding: 0;
  cursor: pointer;
  user-select: none;
  appearance: none;
  /* Remove Firefox dotted outline. */
  &::-moz-focus-inner {
    border-style: none;
  }
  &:focus-visible {
    outline: none;
  }
`;

export const aTagStyles = css`
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;

export const disabledStyles = css`
  pointer-events: none;
  cursor: default;
`;

export const hoverStyles = css`
  &:hover,
  &:focus {
    outline: none;
    text-decoration: underline;
  }
`;

export const textLinkBaseStyle = textBaseStyle;
export const getTextLinkSizeClassName = getTextSizeClassName;
export const getTextLinkWeightClassName = getTextWeightClassName;
export const getTextLinkAlignClassName = getTextAlignClassName;
export const getTextLinkColorClassName = getFontColorClassName;
